import React, { forwardRef } from "react";
import MenuItem, { MenuItemProps } from "@mui/material/MenuItem";

import Link from "../../../vendor/redux-first-router-link";
import resolveNavRoute, { NavRouteContext } from "./nav_bar_redesign_route";
import { RedesignNavItem } from "./nav_bar_redesign_options";

export type Props = Omit<MenuItemProps, "selected"> & {
  item: RedesignNavItem
  selected: boolean
  routeContext: NavRouteContext
  onClose: () => void
};

// One row of the "..." overflow menu: a 32px leading icon box and the label, per the Figma menu
// item (see nav_bar_redesign.css). Routing and the disabled state (an option with no route, e.g. the
// Schedules placeholder) mirror NavBarPageOption. Extra props (autoFocus / tabIndex from MUI's
// MenuList keyboard handling) are forwarded to the MenuItem. The icon is decorative and hidden from
// assistive tech, so the row's accessible name is just its label (the symbol font's ligature text,
// e.g. "settings", would otherwise be read out too).
const NavBarRedesignOverflowItem = forwardRef<HTMLLIElement, Props>(
  ({ item, selected, routeContext, onClose, ...rest }, ref) => {
    return <MenuItem
      {...rest}
      ref={ref}
      className="NavBarRedesign-overflowItem"
      selected={selected}
      disabled={!item.base.routingEvent}
      onClick={onClose}
      component={Link}
      to={resolveNavRoute(item.base, routeContext)}
    >
      <span className="NavBarRedesign-overflowItemIcon" aria-hidden="true">{item.renderIcon(selected)}</span>
      <span className="NavBarRedesign-overflowItemLabel">{item.label}</span>
    </MenuItem>;
  }
);
NavBarRedesignOverflowItem.displayName = "NavBarRedesignOverflowItem";

export default NavBarRedesignOverflowItem;
